export interface BuildGgFilterCommandParams {
  modulePath: string
  types: string[]
  methods?: string[]
  port?: string
}

export function buildGgFilterCommand({
  modulePath,
  types,
  methods = [],
  port = '8888',
}: BuildGgFilterCommandParams): string {
  const normalizedModule = modulePath.trim() || './your-module.jar'
  const typeList = types.map((type) => type.trim()).filter(Boolean)
  const methodList = methods.map((method) => method.trim()).filter(Boolean)

  const typesArg = typeList.length > 0 ? typeList.join(',') : 'Your.Namespace.FacadeClass'

  const command = [`gg ${normalizedModule}`, `--types ${typesArg}`]

  if (methodList.length > 0) {
    command.push(`--methods ${methodList.join(',')}`)
  }

  command.push(`--port ${port}`)

  return command.join(' ')
}
